"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 *
 * Returns an iterator of the own enumerable string keyed-value pairs.
 *
 * @example
 * ```ts
 *
 * [...entries({ a: 1, b: "2", c: true })]
 * // [["a", 1], ["b", "2"], ["c", true]]
 * ```
 *
 *
 * see {@link https://fxts.dev/docs/fromEntries | fromEntries}
 */
function entries(obj) {
    var _a, _b, _c, _i, k;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = obj;
                _b = [];
                for (_c in _a)
                    _b.push(_c);
                _i = 0;
                _d.label = 1;
            case 1:
                if (!(_i < _b.length)) return [3 /*break*/, 4];
                _c = _b[_i];
                if (!(_c in _a)) return [3 /*break*/, 3];
                k = _c;
                if (!Object.prototype.hasOwnProperty.call(obj, k)) return [3 /*break*/, 3];
                return [4 /*yield*/, [k, obj[k]]];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.default = entries;
//# sourceMappingURL=entries.js.map